// PlaybackContext.js
// Provides shared playback state so mixes can be triggered from Deeper page
// and played through the persistent Player

import React, { createContext, useContext, useState, useCallback } from "react";

const PlaybackContext = createContext(null);

export function PlaybackProvider({ children }) {
  // When a mix is set, it overrides the normal radio queue
  const [activeMix, setActiveMix] = useState(null);

  // Called from Deeper page when user clicks a mix
  const playMix = useCallback((mix) => {
    setActiveMix(mix);
  }, []);

  // Called when mix ends to return to radio rotation
  const clearMix = useCallback(() => {
    setActiveMix(null);
  }, []);

  // Check if currently playing a mix
  const isPlayingMix = activeMix !== null;

  return (
    <PlaybackContext.Provider value={{ activeMix, playMix, clearMix, isPlayingMix }}>
      {children}
    </PlaybackContext.Provider>
  );
}

export function usePlayback() {
  const context = useContext(PlaybackContext);
  if (!context) {
    throw new Error("usePlayback must be used within a PlaybackProvider");
  }
  return context;
}
